export default "__VITE_ASSET__2a81cf8f__"